export default "__VITE_ASSET__CVL1857J__"